export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-inpost.fd1c4acd.svg","height":50,"width":100,"blurWidth":0,"blurHeight":0};